import { useDispatch } from 'react-redux';
import { clearTypeModal, clearTypeOfShowModalType, setTypeModal, setTypeOfShowModalType } from '../../../features/modal/modalSlice';
import { CloseIcon } from '../../../assets/icons/Svg';

export default function TypesModal() {

    const dispatch = useDispatch();

    const types = [
        { id: 'product', labelName: 'Product' }, 
        { id: 'category', labelName: 'Category' },
        { id: 'package', labelName: 'Package' },
    ]

    const handleSelectedModalType = (type: string) => {
        if(!type) return;
        if(type === 'product') {
            dispatch(setTypeModal('newProduct'));
            dispatch(setTypeOfShowModalType('productModal'));
        } else if(type === 'category') {
            dispatch(setTypeModal('newCategory'));
            dispatch(setTypeOfShowModalType('categoryModal'));
        } else if(type === 'package') {
            dispatch(setTypeModal('newPackage'));
            dispatch(setTypeOfShowModalType('newPackageModal'));
        }
    }

    const handleCloseTypesModal = () => {
        dispatch(setTypeOfShowModalType('fbTypeModal'));
        dispatch(clearTypeModal());
        dispatch(clearTypeOfShowModalType())
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'
        >
            <div className='relative w-[80%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[40%] lg:w-[25%]'>
                <div className='flex flex-col w-full'>
                    <div className='w-full space-y-3 py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    Please select one
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={handleCloseTypesModal}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <ul className="space-y-1 grid grid-cols-1 md:grid-cols-2 gap-2 md:space-y-0 md:gap-4">
                            {types.map(({ id, labelName }) => (
                                <li
                                    key={id}
                                    className={`flex items-center p-2 rounded border cursor-pointer transition justify-center border-gray-300`}
                                    onClick={() => handleSelectedModalType(id)}
                                >
                                    <label className="flex items-center cursor-pointer w-full text-center justify-center">
                                        <span className="text-sm select-none text-center">
                                            {labelName}
                                        </span>
                                    </label>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
